import React from "react";

const renderOptions = (items, loading, emptyLabel) => {
  if (loading) return <option value="">Cargando...</option>;
  if (!items.length) return <option value="">{emptyLabel}</option>;
  return [
    <option key="all" value="">
      Todos
    </option>,
    ...items.map((item) => (
      <option key={item.id} value={item.id}>
        {item.nombre}
      </option>
    )),
  ];
};

export default function CursosFilters({
  filtros,
  setFiltros,
  limpiarFiltros,
  niveles = [],
  nivelesLoading = false,
}) {
  return (
    <div className="management-card curso-filters-card management-filters-card mb-4">
      <div className="row g-3 align-items-end">
        <div className="col-12 col-md-4">
          <label className="form-label management-label mb-1">Buscar</label>
          <input
            type="text"
            className="form-control"
            placeholder="Curso, código, centro, nivel o especialidad"
            value={filtros.search}
            onChange={(e) => setFiltros((prev) => ({ ...prev, search: e.target.value }))}
          />
        </div>
        <div className="col-6 col-md-4">
          <label className="form-label management-label mb-1">Nivel</label>
          <select
            className="form-select"
            value={filtros.nivel_id}
            onChange={(e) => setFiltros((prev) => ({ ...prev, nivel_id: e.target.value }))}
            disabled={nivelesLoading}
          >
            {renderOptions(niveles, nivelesLoading, "No hay niveles disponibles")}
          </select>
        </div>
        <div className="col-6 col-md-4">
          <label className="form-label management-label mb-1">Estado</label>
          <div className="input-group">
            <select
              className="form-select"
              value={filtros.activo}
              onChange={(e) => setFiltros((prev) => ({ ...prev, activo: e.target.value }))}
            >
              <option value="all">Todos</option>
              <option value="1">Activos</option>
              <option value="0">Inactivos</option>
            </select>
            <button type="button" className="btn management-btn-primary management-btn-tiny" onClick={limpiarFiltros}>
              <i className="bi bi-eraser-fill me-1" />
              Limpiar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


